import { render, staticRenderFns } from "./PolicyCommitteeReport.vue?vue&type=template&id=4f427ff0&scoped=true"
import script from "./PolicyCommitteeReport.vue?vue&type=script&lang=ts"
export * from "./PolicyCommitteeReport.vue?vue&type=script&lang=ts"
import style0 from "./PolicyCommitteeReport.vue?vue&type=style&index=0&id=4f427ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f427ff0",
  null
  
)

export default component.exports